import React, { useEffect } from 'react';
import CustomTab from "../../components/ui/CustomTab";
import { useDispatch } from 'react-redux';
import { pushRoute, setSaveDashboardFormState } from '../../store/globalSlice';

const tabs = [
	{
		label: "Modifications in Scenario",
		to: "Modifications_Scenario",
		value: "/audit/Modifications_Scenario",
	},
	{
		label: "Comments and Attachments",
		to: "Comments_Attachments",
		value: "/audit/Comments_Attachments",
	},
];

const Audit = () => {
  const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setSaveDashboardFormState(false));
      dispatch(pushRoute("audit"));
    }, []);
  return (
    <CustomTab tabs={tabs} />
  )
}

export default Audit;